import { render, staticRenderFns } from "./AtrasoAtendimento.vue?vue&type=template&id=91c243f6&scoped=true"
import script from "./AtrasoAtendimento.vue?vue&type=script&lang=js"
export * from "./AtrasoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./AtrasoAtendimento.vue?vue&type=style&index=0&id=91c243f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c243f6",
  null
  
)

export default component.exports